import { render, staticRenderFns } from "./SetupTestPage2.vue?vue&type=template&id=0d3a0349&scoped=true&"
import script from "./SetupTestPage2.vue?vue&type=script&lang=js&"
export * from "./SetupTestPage2.vue?vue&type=script&lang=js&"
import style0 from "./SetupTestPage2.vue?vue&type=style&index=0&id=0d3a0349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a0349",
  null
  
)

export default component.exports